module.exports = __webpack_public_path__ + "img/marketing-target.0917c9b0.svg";